import React from "react";
import PropTypes from "prop-types";
import { tableStyleCompact, thStyleCompact, tdStyleCompact, sectionTitleStyle } from "./printTableStyles";

export default function BhavaAspectsTable({ bhavaData }) {
    return (
        <div>
            <div style={sectionTitleStyle}>
                භාව උපස්ථාන හා නිවේදකත්වය
            </div>
            <table style={tableStyleCompact}>
                <thead>
                    <tr>
                        <th style={thStyleCompact}>භාවය</th>
                        <th style={thStyleCompact}>නැකත</th>
                        <th style={thStyleCompact}>උප ග්‍රහ</th>
                        <th style={thStyleCompact}>ලැගුම්ගෙන සිටි ග්‍රහයෝ</th>
                        <th style={thStyleCompact}>ලැගුම්ගත්තන්ගේ නැකත්වල තැන්පත් ග්‍රහයින්</th>
                        <th style={thStyleCompact}>අධිපති</th>
                        <th style={thStyleCompact}>අධිපතිගේ නැකත්වල තැන්පත් ග්‍රහයින්</th>
                    </tr>
                </thead>
                <tbody>
                    {bhavaData.map((row, idx) => (
                        <tr key={idx}>
                            <td style={tdStyleCompact}>{row.bhavaIndex}</td>
                            <td style={tdStyleCompact}>{row.nekatha}</td>
                            <td style={tdStyleCompact}>{row.upaGraha}</td>
                            <td style={tdStyleCompact}>{row.gahasInBhava}</td>
                            <td style={tdStyleCompact}>{row.bnL1}</td>
                            <td style={tdStyleCompact}>{row.bnL4}</td>
                            <td style={tdStyleCompact}>{row.bnL3}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

BhavaAspectsTable.propTypes = {
    bhavaData: PropTypes.array.isRequired,
};
